import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon.jsx';

const { FiShield, FiUsers, FiTrendingUp } = FiIcons;

const Guarantee = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="bg-white border-4 border-[#c5a059]/20 rounded-[3rem] p-10 md:p-14 max-w-4xl mx-auto shadow-xl relative">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#2c3a50] p-4 rounded-full border-4 border-white">
              <SafeIcon icon={FiShield} className="w-10 h-10 text-[#c5a059]" />
            </div>
            
            <h2 className="text-3xl md:text-4xl font-black text-[#2c3a50] mb-6 mt-6 uppercase tracking-tight">
              7 dias de garantia
            </h2>
            
            <p className="text-lg text-gray-600 leading-relaxed mb-10 font-medium max-w-2xl mx-auto">
              Sua satisfação e segurança são nossa prioridade. Oferecemos um período de experimentação para que você conheça a qualidade do nosso método sem preocupações.
            </p>

            <a 
              href="https://pay.kiwify.com.br/IotGhts" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block bg-[#2c3a50] text-white px-12 py-5 rounded-full text-lg font-bold hover:bg-[#c5a059] transition-all transform hover:scale-105 shadow-xl"
            >
              GARANTIR MINHA VAGA AGORA
            </a>
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="grid md:grid-cols-3 gap-8 text-center"
        >
          <div className="p-6">
            <div className="bg-[#2c3a50]/5 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <SafeIcon icon={FiUsers} className="w-8 h-8 text-[#c5a059]" />
            </div>
            <h3 className="text-lg font-bold text-[#2c3a50] mb-2">Famílias Transformadas</h3>
            <p className="text-gray-500 text-sm font-medium">Centenas de pais já aplicam nossos métodos com sucesso.</p>
          </div>
          
          <div className="p-6">
            <div className="bg-[#2c3a50]/5 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <SafeIcon icon={FiTrendingUp} className="w-8 h-8 text-[#c5a059]" />
            </div>
            <h3 className="text-lg font-bold text-[#2c3a50] mb-2">Prática Clínica</h3>
            <p className="text-gray-500 text-sm font-medium">Conteúdo baseado em mais de 10 anos de experiência real.</p>
          </div>

          <div className="p-6">
            <div className="bg-[#2c3a50]/5 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <SafeIcon icon={FiShield} className="w-8 h-8 text-[#c5a059]" />
            </div>
            <h3 className="text-lg font-bold text-[#2c3a50] mb-2">Acesso Seguro</h3>
            <p className="text-gray-500 text-sm font-medium">Plataforma de pagamento certificada e segura.</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Guarantee;